<span class="p-overlay-badge" *ngIf="type === 'icon'">
  <i class="pi pi-bell" [style]="viewStyle"></i>
  <span class="p-badge" [style]="badgeStyle">{{ badgeNumber || 0 }}</span>
</span>
<span class="p-overlay-badge" *ngIf="type === 'button'">
  <button pButton type="button" label="{{ text }}" [style]="viewStyle"></button>
  <span class="p-badge p-badge-warning" [style]="badgeStyle">{{
    badgeNumber || 0
  }}</span>
</span>
